module.exports = __webpack_public_path__ + "img/hygl.cc0df9a5.png";